(ns ui.captions.overlay
  "Shows the captions of the video clips on the editor2 stage: a layer
   above all clips with, per captioned clip, the caption style's
   composition in the player, with the words of the clip's asset that
   fall into the clip's range as `words` variable. editor2 drives the
   player like the clip's <video> element (`captions-<clip uuid>`, see
   `ui.editor2.actions/media-elements`)."
  (:require [app.captions.words :as words]
            [ui.captions.query :as query]
            [ui.editor2.defaults :as defaults]
            [ui.editor2.extension-points :as extension-points]
            [ui.hyperframes-templates.composition :as hf-composition]
            [ui.hyperframes-templates.player :as player]))

(defn variables
  [clip]
  {"words" (words/composition-json
             (words/clip-words (:asset/words (:clip/asset clip))
                               (query/clip-range clip)))})

(defn clip-overlay
  "The player of one clip's captions, hidden while the playhead is
   outside the clip like the clips of the stage are."
  [state playhead-position clip]
  (let [clip-uuid (:clip/uuid clip)]
    [:div {:replicant/key (str "captions-" clip-uuid)
           :style (cond-> {:position "absolute"
                           :top "0px"
                           :left "0px"
                           :width (str (:design/width defaults/defaults) "px")
                           :height (str (:design/height defaults/defaults) "px")}
                    (not (<= (:clip/start clip)
                             playhead-position
                             (:clip/end clip)))
                    (assoc :display "none"))}
     (player/element {:id (str "captions-" clip-uuid)
                      :template-id (str "captions/" (query/style clip))
                      :variables (variables clip)
                      :width (:design/width defaults/defaults)
                      :height (:design/height defaults/defaults)
                      :on-mount (hf-composition/seek-when-ready state clip)
                      :style {:display "block"
                              :width "100%"
                              :height "100%"
                              :pointer-events "none"}})]))

(defmethod extension-points/composition-overlay :captions
  [{:keys [state]} _kind]
  (when-let [clips (seq (query/captioned-clips state))]
    (into [:div {:class ["absolute" "inset-0" "pointer-events-none"]}]
          (map (partial clip-overlay
                        state
                        (get-in state [:editor2 :playhead-position] 0))
               clips))))
